<template>
  <div class="book-list un-tran">
    <div class="book" v-for="(r, index) in tRecords" :key="r.category + index" @click="goTo(r)">
      <img class="cover" :id="r.bookId"/>
      <div class="des">
        <div class="title">{{ r.title }} <div class="show-more" slot="reference" @click.stop='showInfoDrawer(r)'>查看详情</div></div>
        <!-- <div class="des-text" :title="r.summary">{{ r.summary }}</div> -->
        <div class="keywords"><div>作者:</div><div class="word">{{ r.creator }}</div></div>
        <div class="keywords"><div>版本:</div><div class="word">{{ r.edition }}</div></div>
        <div class="keywords"><div>四部分类子类:</div><div class="word">{{ r.fdcSubType }}</div></div>
        <div class="keywords">
          <div>关键词:</div>
          <div class="word">{{ r.keyword }}</div>
        </div>
      </div>
    </div>
    <el-drawer :size='600' :title="currentRecord['title']" :visible.sync="metaInfoDrawerShow"
      direction="rtl" :append-to-body="true" :modal-append-to-body="false">
      <div class="info-drawer-view">
        <div class="keywords info-line-view" v-for="(field, idx) in typeMeta.all"
          :key="'bookMetaData-' + field.key + idx">
          <div class="title">{{ field.name }}:</div>
          <div class="word" :title="currentRecord[field.key]">{{ currentRecord[field.key] }}</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// import searchApi from '@/api/search.js'
import userActionsApi from '@/api/userActions.js'
import { mapGetters } from 'vuex'
import { getBase64FromSinglePDF } from '@/utils'
import typeMeta from './typeMeta.json'
export default {
  data () {
    return {
      typeMeta,
      metaInfoDrawerShow: false,
      otherInfoDrawerShow: false,
      currentInfoType: null,
      currentRecord: {}
    }
  },
  props: {
    records: Array
  },
  computed: {
    ...mapGetters(['isTra', 'library']),
    tRecords () {
      return this.isTra
        ? this.records.map(r => {
            return {
              originInfos: r.originInfos,
              ...JSON.parse(r.originInfos)
            }
          })
        : this.records
    }
  },
  methods: {
    goTo (record) {
      console.log(record)
      this.addClickRecord(record)
      let url = window.location.origin + window.location.pathname
      window.open(`${url}#/detail?bookId=${record.bookId}`)
    },
    addClickRecord (item) {
      userActionsApi.addUserAction({
        actionCode: 'resourceClick',
        bookId: item.bookId,
        resourceId: item.id,
        resourceCategory: 'bookMetaData',
        resourceInfos: JSON.stringify(this.records.find(recordItem => recordItem.id + '' === item.id + ''))
      })
    },
    showInfoDrawer (item) {
      this.metaInfoDrawerShow = true;
      this.currentRecord = item;
    },
    async initImg () {
      let bookFilePath = process.env.NODE_ENV === 'production' ? this.library.bookFilePath : 'http://localhost:8047/book'
      for (let item of this.tRecords) {
        let src = await getBase64FromSinglePDF(`${bookFilePath}/pdf/${item.bookId}/0001/0001.pdf`)
        // getBase64FromSinglePDF(`${bookFilePath}/pdf/${item.bookId}/0001/0001.pdf`).then(src => {
        //   document.getElementById(item.bookId).setAttribute('src', src)
        // })
        document.getElementById(item.bookId).setAttribute('src', src)
      }
    }
  },
  async mounted () {
    if (this.records) this.initImg()
  },
  watch: {
    records () {
      this.initImg()
    },
    isTra () {
      this.initImg()
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.book-list {
  width: 100%;
  border-top: 2px solid #7c1823;
  border-bottom: 2px solid #7c1823;
  display: flex;
  flex-direction: column;
  padding-top: 6px;
  //   justify-content: space-between;
}
.book {
  width: 100%;
  padding: 12px 20px;
  border-bottom: 1px solid #a6a6a6;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  margin-top: 26px;
  .des {
    margin-top: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      color: #4d4030;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .show-more {
    .font-size-default;
    color: #7C1823;
  }
    .des-text {
      color: #7a7374;
      // text-indent: 2em;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    // .author {
    //   color: #7a7374;
    // }
    .keywords {
      display: flex;
      align-items: center;
      color: #4d4030;
      .word {
        margin-left: 18px;
        border-radius: 4px;
        color: #7a7374;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
      }
    }
  }
  .des-others {
    margin-top: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      color: #4d4030;
      font-weight: bold;
    }
    .keywords {
      display: flex;
      align-items: center;
      color: #4d4030;
      .word {
        margin-left: 18px;
        border-radius: 4px;
        color: #7a7374;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
        max-width: 1000px;
      }
    }
  }
  .lock-item {
        display: inline-block;
        color: white;
        background-color: #7C1823;
        border-radius: 4px;
        padding: 4px 20px;
        margin-left: 24px;
        letter-spacing: 2px;
  }
}
// @media screen and (min-width: 769px) {
  .book-list {
    height: 2016px;
  }
  .book {
    height: 225px;
  }
  .cover {
    width: 150px;
    height: 200px;
  }
  .des {
    height: 190px;
    width: 940px;
    .title {
      .font-size-extra-big;
    }
    .des-text {
      .font-size-medium;
    }
    .keywords {
      .font-size-medium;
      .word {
        max-width: 870px;
      }
    }
  }
  .des-others {
    height: 190px;
    width: 1240px;
    .title {
      .font-size-extra-big;
    }
    .keywords {
      .font-size-medium;
    }
  }
  .lock-item {
    .font-size-default;
  }
</style>
<style lang='less' scoped>
@import "~@/styles/variables.less";
.info-drawer-view {
  width: 100%;
  height: 90%;
  padding: 10px;

  .info-line-view {
    font-family: "FangZhengKaiTi-GBK";
    display: flex;
    margin-bottom: 10px;
    border-bottom: solid 1px rgb(247, 247, 247);
  }

  .title {
    width: 140px;
    flex-shrink: 0;
    font-weight: bold;
  }

  .recommends {
    font-family: "FangZhengKaiTi-GBK";
    margin-top: 20px;
    ;

    .recommend-title {
      .font-size-medium;
      color: #7C1823;
    }

    .recommend {
      // display: flex;

      .re-word {
        margin-left: 18px;
        text-decoration: underline;
        cursor: pointer;
        font-weight: bold;

        &:hover {
          color: #7C1823;
        }
      }
    }
  }
}

::v-deep .el-drawer__header {
  font-weight: bold;
  font-family: "FangZhengKaiTi-GBK";
  color: black;
  .font-size-medium;
}
</style>
